import { OclExpressionConstraint } from '../constraint.js';
export class OclConstraintRegistry {
    constructor(schema) {
        this.schema = schema;
        this.constraints = [];
    }
    addConstraint(constraint) {
        this.constraints.push(this.createExpressionConstraint(constraint));
    }
    getConstraintsForProductType(productType) {
        return this.constraints
            .filter(c => c.definition.type === productType)
            .map(c => c.expression);
    }
    createExpressionConstraint(constraint) {
        return {
            expression: new OclExpressionConstraint(constraint.oclExpression, constraint.errorMessage, this.schema),
            definition: constraint
        };
    }
}
//# sourceMappingURL=OclConstraintRegistry.js.map